import { render, staticRenderFns } from "./InviteActivityRecord.vue?vue&type=template&id=228d9a78&scoped=true"
import script from "./InviteActivityRecord.vue?vue&type=script&lang=js"
export * from "./InviteActivityRecord.vue?vue&type=script&lang=js"
import style0 from "./InviteActivityRecord.vue?vue&type=style&index=0&id=228d9a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d9a78",
  null
  
)

export default component.exports